import { toast } from "react-toastify";
import { CONVERSATION_MATRIX_GROUP } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

const buildQueryUrl = (base, params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.append(key, String(value));
  });
  const qs = search.toString();
  return qs ? `${base}?${qs}` : base;
};

export const fetchConversationMatrixGroupTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(CONVERSATION_MATRIX_GROUP.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** GET `conversation-matrix-group` — group dropdown / list options. */
export const getConversationMatrixGroupList = async (data = {}) => {
  try {
    const url = buildQueryUrl(CONVERSATION_MATRIX_GROUP.LIST, data);
    const response = await GET(url);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitConversationMatrixGroupFilterData = async (data = {}) => {
  try {
    const response = await POST(CONVERSATION_MATRIX_GROUP.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addConversationMatrixGroup = async (data = {}) => {
  try {
    const response = await POST(CONVERSATION_MATRIX_GROUP.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateConversationMatrixGroup = async (id, data = {}) => {
  try {
    const response = await PUT(CONVERSATION_MATRIX_GROUP.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getConversationMatrixGroupById = async (data = {}) => {
  try {
    const url = data?.Id
      ? CONVERSATION_MATRIX_GROUP.BY_ID(data.Id)
      : CONVERSATION_MATRIX_GROUP.LIST;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
